module.exports = __webpack_public_path__ + "static/media/logo.83afed63.svg";